module.exports = __webpack_public_path__ + "media/2.8a124f1a.mp3";